var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereum1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5567 32.893C30.1992 33.0359 29.8009 33.0359 29.4434 32.893L25.6064 31.3582L30.0001 40.1454L34.3937 31.3582L30.5567 32.893Z",
    fill: "#DC3CCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29.8846L35.2771 27.7739L30 19.3304L24.7229 27.7739L30 29.8846Z",
    fill: "#DC3CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 9.00012C18.402 9.00012 9 18.4021 9 30C9 41.5979 18.402 50.9999 29.9999 50.9999C41.5978 50.9999 50.9998 41.5979 50.9998 30C50.987 18.4076 41.5923 9.01294 29.9999 9.00012ZM38.8416 29.171L31.3416 44.171C30.9713 44.9121 30.0699 45.2124 29.3293 44.8421C29.0386 44.697 28.8033 44.4617 28.6582 44.171L21.1582 29.171C20.9252 28.7032 20.9518 28.1479 21.2282 27.7043L28.7282 15.7045C29.2267 15.0023 30.1995 14.8366 30.9017 15.3351C31.045 15.4367 31.17 15.5612 31.2716 15.7045L38.7711 27.7043C39.0481 28.1479 39.0746 28.7032 38.8416 29.171Z",
    fill: "#DC3CCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.4312 0 0 13.4312 0 30C0 46.5688 13.4312 60 30 60C46.5688 60 60 46.5688 60 30C59.9817 13.439 46.561 0.0183105 30 0ZM30 54.0001C16.745 54.0001 5.99991 43.255 5.99991 30C5.99991 16.745 16.745 5.99991 30 5.99991C43.255 5.99991 54.0001 16.745 54.0001 30C53.985 43.2486 43.2486 53.985 30 54.0001Z",
    fill: "#DC3CCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum1);
export default __webpack_public_path__ + "static/media/ethereum-1.e6126225c4d1c3c21d913c14d2fd59bc.svg";
export { ForwardRef as ReactComponent };